export default __webpack_public_path__ + "locales/sk/DeleteSelfProfileDialog.json?hash=984ba6dc5dab3e7877bed925343e2e6d";